import { render, staticRenderFns } from "./InfoAreas.vue?vue&type=template&id=2e41e1ac"
import script from "./InfoAreas.vue?vue&type=script&lang=js"
export * from "./InfoAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports